import { Fragment } from "react";
import { Button } from "core/components/form-controls";
import { _t } from "core/language";
import GoToOptionButton from './../../components/GoToOptionButton';
import AddIngredientSwiperButton from './../../components/AddIngredientSwiperButton'
import useSelectIngredient from './../../hooks/useSelectIngredient';
import type { TIngredient } from "./../../store/types";
import MyIngredientItem from './MyIngredientItem'
import Filter from './Filter'

const MyIngredientList = ({
  ingredients,
  ingredientSelected,
  onAddByList,
  sort,
  setSort,
  onRemoveMyIngredients,
}: {
  ingredients: TIngredient[],
  ingredientSelected: TIngredient[],
  onAddByList?: () => void,
  sort?: any,
  setSort?: any,
  onRemoveMyIngredients?: (item: TIngredient) => void,
}) => {
  const {
    ingredientSelecting,
    checkIngredientSelected,
    selectIngredient,
    selectAllIngredient,
    isSelectAll,
  } = useSelectIngredient(ingredients, ingredientSelected)

  return (
    <Fragment>
      <div className="flex justify-between items-center gap-2.5 mb-5 text-[13px]">
        <Button
          label={isSelectAll ? _t('ingredient.deselect_all') : _t('ingredient.select_all')}
          classBtn="w-full !py-[10px] font-medium tracking-tighter"
          onClickBtn={selectAllIngredient}
          size='sm'
        />
        <AddIngredientSwiperButton
          className="w-full !py-[10px] !font-medium !text-[14px] tracking-tighter"
          onAddByList={onAddByList}
          size='sm'
        />
      </div>
      <div className="flex justify-between items-center mb-2 text-[13px]">
        <label>
          {_t('ingredient.selecting')}
          <span className="text-primary ms-1">
            {ingredients.length}
          </span>
        </label>
        <Filter
          sort={sort}
          setSort={setSort}
        />
      </div>
      <div className="grid grid-cols-2 gap-x-2 mb-[70px]">
        {ingredients.map((ingredient: TIngredient) => (
          <MyIngredientItem
            key={ingredient.id}
            ingredient={ingredient}
            isSelected={checkIngredientSelected(ingredient)}
            onSelectIngredient={selectIngredient}
            onRemoveMyIngredients={onRemoveMyIngredients}
          />
        ))}
      </div>
      {ingredients.length ? (
        <div className="pr-8 pb-[50px] fixed bottom-[60px] bg-white w-full !font-medium">
          <GoToOptionButton ingredients={ingredientSelecting} />
        </div>
      ) : null}
    </Fragment>
  )
}

export default MyIngredientList
